<template lang="pug">
div
  div
    v-select(
      clearable,
      @input='update',
      v-model='block.value.complexes',
      :items='list',
      item-value='id',
      item-text='name',
      label='Выберите комплексы'
      multiple
      chips
    )
  div(style='margin-top: 12px')
    .label Этажи
    v-container.grid-list-xl.fluid(style='padding: 0px')
      v-layout(wrap)
        v-flex(xs6)
          v-text-field(
            label='С',
            persistent-hint,
            v-model='block.value.floor.min',
            @input='$emit("update", block)'
          )
        v-flex(xs6)
          v-text-field(
            label='По',
            persistent-hint,
            v-model='block.value.floor.max',
            @input='$emit("update", block)'
          )
  div(style='margin-top: 12px')
    .label Площадь
    v-container.grid-list-xl.fluid(style='padding: 0px')
      v-layout(wrap)
        v-flex(xs6)
          v-text-field(
            label='От',
            persistent-hint,
            v-model='block.value.square.min',
            @input='$emit("update", block)'
          )
        v-flex(xs6)
          v-text-field(
            label='До',
            persistent-hint,
            v-model='block.value.square.max',
            @input='$emit("update", block)'
          )
  div(style='margin-top: 12px')
    .label Цена
    v-container.grid-list-xl.fluid(style='padding: 0px')
      v-layout(wrap)
        v-flex(xs6)
          v-text-field(
            label='От',
            persistent-hint,
            v-model='block.value.price.min',
            @input='$emit("update", block)'
          )
        v-flex(xs6)
          v-text-field(
            label='До',
            persistent-hint,
            v-model='block.value.price.max',
            @input='$emit("update", block)'
          )
  div(style='margin-top: 12px')
    v-container.grid-list-xl.fluid(style='padding: 0px')
      v-layout(wrap)
        v-flex(xs9)
          .label Комнатность
          .rooms
            v-checkbox(
              :key='room',
              :value='room',
              :label='String(room)',
              v-model='block.value.rooms',
              color='primary',
              v-for='room in rooms',
              @change='$emit("update", block)'
            )
        v-flex(xs3)
          .label Лимит
          v-text-field(
            persistent-hint,
            :default = 6,
            v-model='block.value.limit',
            @input='$emit("update", block)'
          )

</template>

<script>
import http from '@/http'
import BaseBlock from './BaseBlock'
import { xor } from 'lodash'

export default {
  extends: BaseBlock,

  data: function () {
    return {
      list: [],
      rooms: [1, 2, 3, 4, 5],
    }
  },

  async created() {
    try {
      const response = await http.get('/seo/blogs/attributes')
      this.list = response.data.complexes
    } catch (e) {
      this.$root.showSnack('Ошибка загрузки буннеров')
    }
  },

  methods: {
    toggleRooms(count) {
      this.block.value.rooms = xor(this.block.value.rooms, [count])
    },

    update(val) {
      this.block.value.complex = val || []
      this.$emit('update', this.block)
    },
  },

  computed: {
    complexes: {
      get: function() {
        if (!this.block.value.complexes) return []
        return this.block.value.complex.split(',')
      },
      set: function(val) {
        this.block.value.complexes = val.join(',')
      }
    }
  }
}
</script>

<style scoped>
.rooms {
  display: flex;
}
.rooms > div {
  flex: 0 0 auto;
  margin-right: 24px;
}
</style>
